export const IA_CONTAINER_MESSAGE_CLASSNAME = 'flex'
